module.exports = __webpack_public_path__ + "static/img/contact_logo1_h.fda3711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact_logo1_h.png
// module id = EkL8
// module chunks = 1